import { helpers } from '@vuelidate/validators'

export default length =>
  helpers.withParams(
    { type: 'sameArrayLength', length },
    value => Array.isArray(value) && value.length === length,
  )
